import HookFormTextField, {
  HookFormTextFieldProps,
} from '~/components/atoms/HookForm/TextField/HookFormTextField.tsx';
import { ContactSchema, CustomerSchema } from '../CustomerFormProvider.tsx';
import { GridLayoutContainer, GridLayoutItem, Typography } from '~/index.ts';
import { ReactNode } from 'react';
import { CustomerSectionProps } from '../CustomerForm.tsx';
import { formatPhoneOnChangeEvent } from '~/utils/formatters/index.ts';

export interface CoapplicantProps extends CustomerSectionProps {
  currentContact: ContactSchema;
}

const CoapplicantSection: React.FC<CoapplicantProps> = ({
  control,
  formTexts,
  layoutOverrides,
  formMode,
  isEditing,
  currentContact,
  disabled,
}) => {
  const renderEditFields = (): ReactNode => {
    const fieldDefinitions: Array<
      Omit<HookFormTextFieldProps<CustomerSchema>, 'control' | 'onChange'> & {
        flexPercentage: number;
      }
    > = [
      {
        name: 'coapplicant.firstName',
        placeholder: formTexts.coapplicant.firstName,
        flexPercentage: 50,
      },
      {
        name: 'coapplicant.middleName',
        placeholder: formTexts.coapplicant.middleName,
        flexPercentage: 50,
      },
      {
        name: 'coapplicant.lastName',
        placeholder: formTexts.coapplicant.lastName,
        flexPercentage: 50,
      },
      {
        name: 'coapplicant.email',
        placeholder: formTexts.coapplicant.email,
        flexPercentage: 100,
      },
      {
        name: 'coapplicant.mobilePhone',
        placeholder: formTexts.coapplicant.mobilePhone,
        transformOnChangeValue: formatPhoneOnChangeEvent,
        flexPercentage: 50,
      },
      {
        name: 'coapplicant.homePhone',
        placeholder: formTexts.coapplicant.homePhone,
        transformOnChangeValue: formatPhoneOnChangeEvent,
        flexPercentage: 50,
      },
    ];
    return fieldDefinitions.map((fieldDef) => {
      return (
        <GridLayoutItem
          key={fieldDef.name}
          flexPercentage={fieldDef.flexPercentage}
        >
          <HookFormTextField
            fullWidth
            control={control}
            name={fieldDef.name}
            placeholder={fieldDef.placeholder}
            transformOnChangeValue={fieldDef.transformOnChangeValue}
            size={layoutOverrides?.textField?.size}
            disabled={disabled}
          />
        </GridLayoutItem>
      );
    });
  };

  const renderPreviewFields = (): ReactNode => {
    return (
      <>
        <GridLayoutItem>
          <Typography
            styleOverrides={{ color: 'text.secondary' }}
          >{`${currentContact.firstName} ${currentContact.middleName} ${currentContact.lastName}`}</Typography>
        </GridLayoutItem>
        <GridLayoutItem>
          <Typography styleOverrides={{ color: 'text.secondary' }}>
            {currentContact.email}
          </Typography>
        </GridLayoutItem>
        <GridLayoutItem>
          <Typography
            styleOverrides={{
              color: 'text.secondary',
              display: 'inline',
              margin: '0 10px 0 0',
            }}
          >
            {currentContact.mobilePhone}
          </Typography>
          <Typography
            styleOverrides={{ color: 'text.secondary', display: 'inline' }}
          >
            {currentContact.homePhone}
          </Typography>
        </GridLayoutItem>
      </>
    );
  };

  const showEditFields = formMode === 'add' || isEditing;
  const spacing = showEditFields ? 3 : 1;
  const sectionContent = showEditFields
    ? renderEditFields()
    : renderPreviewFields();
  return (
    <GridLayoutContainer spacing={spacing}>
      {sectionContent}
    </GridLayoutContainer>
  );
};

export default CoapplicantSection;
